var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAntragClose = function SvgAntragClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.83 3.976-1.454-2.39a1.194 1.194 0 0 0-1.143-.623H3.767a1.72 1.72 0 0 0-1.247.52L1.17 3.976a1.917 1.917 0 0 0-.52 1.247v1.454H2v10.285a2.084 2.084 0 0 0 2.078 2.078h11.844a2.084 2.084 0 0 0 2.077-2.078V6.677h1.351V5.223a1.917 1.917 0 0 0-.52-1.247zm-2.908 12.986H4.078V6.677h11.844v10.285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m11.4 11.802 1.5-1.6-1.4-1.4-1.5 1.5-1.5-1.5-1.4 1.4 1.5 1.6-1.4 1.4 1.4 1.4 1.4-1.4 1.4 1.4 1.4-1.4-1.4-1.4z"
  }))));
};
export default SvgAntragClose;